import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@finance/context/AuthContext";
import { errMsg } from "@finance/lib/api";
import { Button } from "@finance/components/ui/button";
import { Input } from "@finance/components/ui/input";
import { Label } from "@finance/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@finance/components/ui/dialog";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
.lynx-login{--ink:#12151A;--orange:#1B4383;--orange-dark:#122E5C;--teal:#122E5C;--white:#FFFFFF;--steel:#5E6570;--line:#E6E4DF;font-family:'IBM Plex Sans',sans-serif;color:var(--ink);-webkit-font-smoothing:antialiased;}
.lynx-login *{box-sizing:border-box;}
.lynx-login .scene{position:relative;min-height:100vh;width:100%;display:flex;align-items:center;background:linear-gradient(100deg,rgba(10,12,14,0.72) 0%,rgba(10,12,14,0.38) 42%,rgba(10,12,14,0.05) 62%,rgba(10,12,14,0.15) 100%),linear-gradient(0deg,rgba(6,7,8,0.55) 0%,rgba(6,7,8,0) 32%),url('https://images.unsplash.com/photo-1582280871722-424e91cbee8b?fm=jpg&q=80&w=2400&auto=format&fit=crop') center/cover no-repeat;}
.lynx-login .mark{height:52px;width:auto;display:block;object-fit:contain;}
.lynx-login .topleft{position:absolute;top:56px;left:56px;z-index:2;max-width:640px;}
.lynx-login .topleft .mark{margin-bottom:22px;}
.lynx-login .topleft h1{font-weight:700;text-transform:uppercase;font-size:44px;line-height:1.08;letter-spacing:0.005em;color:var(--white);margin:0 0 16px;}
.lynx-login .eyebrow{font-size:13px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#D8D5CD;}
.lynx-login .eyebrow span{margin:0 10px;color:var(--orange);}
.lynx-login .bottomleft{position:absolute;left:56px;bottom:56px;z-index:2;max-width:620px;}
.lynx-login .bottomleft h2{font-weight:700;text-transform:uppercase;font-size:32px;line-height:1.14;color:var(--white);margin:0 0 10px;}
.lynx-login .bottomleft p{font-style:italic;font-weight:400;font-size:18px;color:#C8CBCE;margin:0;}
.lynx-login .stage{position:relative;z-index:2;margin-left:auto;padding-right:9vw;}
.lynx-login .card{width:356px;background:var(--white);border-radius:10px;padding:36px 32px 28px;text-align:center;box-shadow:0 30px 70px -18px rgba(0,0,0,0.5);}
.lynx-login .card .mark{margin:0 auto 20px;height:44px;}
.lynx-login .card h2{font-size:22px;font-weight:700;margin:0 0 6px;color:var(--ink);}
.lynx-login .card>p{font-size:13.5px;color:var(--steel);margin:0 0 26px;}
.lynx-login .lg-err{margin:0 0 18px;border:1px solid #FBD5D5;background:#FDECEC;color:#B42318;border-radius:6px;padding:10px 12px;font-size:13px;text-align:left;}
.lynx-login .field{margin-bottom:16px;text-align:left;}
.lynx-login label{display:block;font-size:11px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:var(--steel);margin-bottom:7px;}
.lynx-login .field-shell{border:1px solid var(--line);border-radius:6px;background:var(--white);display:flex;align-items:center;transition:border-color .15s ease;}
.lynx-login .field-shell:focus-within{border-color:var(--orange);}
.lynx-login input{width:100%;border:none;background:transparent;padding:12px 13px;font-family:'IBM Plex Sans',sans-serif;font-size:14px;color:var(--ink);border-radius:6px;}
.lynx-login input:focus{outline:none;}
.lynx-login input::placeholder{color:#AEB0AA;}
.lynx-login .toggle-pw{background:none;border:none;cursor:pointer;padding:0 13px;font-family:'IBM Plex Sans',sans-serif;font-size:11px;color:var(--steel);white-space:nowrap;}
.lynx-login .toggle-pw:hover{color:var(--ink);}
.lynx-login .row-end{display:flex;justify-content:flex-end;margin:2px 0 22px;}
.lynx-login .forgot{font-size:12.5px;color:var(--orange-dark);text-decoration:none;font-weight:500;background:none;border:none;cursor:pointer;padding:0;}
.lynx-login .forgot:hover{text-decoration:underline;}
.lynx-login button.submit{width:100%;padding:13px 18px;background:var(--orange);color:var(--white);border:none;border-radius:6px;font-family:'IBM Plex Sans',sans-serif;font-size:14.5px;font-weight:600;cursor:pointer;transition:background .15s ease;}
.lynx-login button.submit:hover{background:var(--orange-dark);}
.lynx-login button.submit:disabled{opacity:.7;cursor:default;}
.lynx-login .authorized{margin-top:16px;font-size:11.5px;color:#A6A9A4;}
@media (max-width:900px){
.lynx-login .scene{flex-direction:column;justify-content:flex-end;background:linear-gradient(180deg,rgba(10,12,14,0.35) 0%,rgba(10,12,14,0.5) 45%,rgba(10,12,14,0.92) 82%,rgba(10,12,14,0.97) 100%),url('https://images.unsplash.com/photo-1582280871722-424e91cbee8b?fm=jpg&q=80&w=1400&auto=format&fit=crop') center/cover no-repeat;}
.lynx-login .topleft{position:static;padding:40px 24px 0;max-width:none;}
.lynx-login .topleft h1{font-size:30px;}
.lynx-login .bottomleft{position:static;padding:0 24px;margin-top:26px;}
.lynx-login .bottomleft h2{font-size:22px;}
.lynx-login .stage{margin:0;padding:28px 20px 40px;display:flex;justify-content:center;width:100%;}
.lynx-login .card{width:100%;max-width:380px;}
}
`;

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotSending, setForgotSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/my-actions");
    } catch (err) {
      // On the sign-in screen a 401 means "wrong email/password" — show the backend's exact reason
      // (attempts left / lockout) instead of the generic "session expired" text errMsg gives for 401s.
      const detail = err?.response?.data?.detail;
      setError((typeof detail === "string" && detail) || errMsg(err) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const sendForgot = async () => {
    if (!forgotEmail.trim()) { toast.error("Enter your email address."); return; }
    setForgotSending(true);
    try {
      await axios.post(`${BASE}/api/finance/auth/forgot-password`, { email: forgotEmail.trim() });
      setForgotOpen(false);
      toast.success("If that email is registered, a reset link is on its way. Check your inbox (and spam).");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setForgotSending(false);
    }
  };

  return (
    <div className="lynx-login">
      <style>{CSS}</style>
      <div className="scene">
        <div className="topleft">
          <img className="mark" src="/somcore-logo.png" alt="Somcore logo" />
          <h1>Somcore Finance<br />Module</h1>
          <div className="eyebrow">SECURE<span>•</span>ACCURATE<span>•</span>CONNECTED</div>
        </div>

        <div className="bottomleft">
          <h2>Finance as solid as the ground you work</h2>
          <p>Every transaction accounted for.</p>
        </div>

        <div className="stage">
          <div className="card">
            <img className="mark" src="/somcore-logo.png" alt="Somcore logo" />
            <h2>Welcome back</h2>
            <p>Sign in to your finance workspace.</p>

            {error && <div className="lg-err" data-testid="login-error">{error}</div>}

            <form onSubmit={submit} data-testid="login-form">
              <div className="field">
                <label htmlFor="email">Email</label>
                <div className="field-shell">
                  <input id="email" type="email" placeholder="name@company.com" autoComplete="username"
                    value={email} data-testid="login-email" onChange={(e) => setEmail(e.target.value)} required />
                </div>
              </div>
              <div className="field">
                <label htmlFor="password">Password</label>
                <div className="field-shell">
                  <input id="password" type={showPw ? "text" : "password"} placeholder="••••••••••" autoComplete="current-password"
                    value={password} data-testid="login-password" onChange={(e) => setPassword(e.target.value)} required />
                  <button type="button" className="toggle-pw" data-testid="toggle-password"
                    onClick={() => setShowPw((v) => !v)}>{showPw ? "hide" : "show"}</button>
                </div>
              </div>
              <div className="row-end">
                <button type="button" className="forgot" data-testid="forgot-password-link"
                  onClick={() => { setForgotEmail(email); setForgotOpen(true); }}>Forgot password?</button>
              </div>
              <button type="submit" className="submit" disabled={loading} data-testid="login-submit">
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>

            <div className="authorized">Authorized access only</div>
          </div>
        </div>
      </div>

      <Dialog open={forgotOpen} onOpenChange={setForgotOpen}>
        <DialogContent className="max-w-sm" data-testid="forgot-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Reset your password</DialogTitle>
            <DialogDescription>Enter your account email and we'll send you a secure link to set a new password. The link expires in 60 minutes.</DialogDescription>
          </DialogHeader>
          <div>
            <Label className="lx-label">Email</Label>
            <Input type="email" className="mt-1" data-testid="forgot-email" value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); sendForgot(); } }} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setForgotOpen(false)}>Cancel</Button>
            <Button className="bg-[#1B4383] hover:bg-[#122E5C]" disabled={forgotSending} data-testid="forgot-submit" onClick={sendForgot}>
              {forgotSending ? "Sending…" : "Send reset link"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
